import styled from '@emotion/styled';

export const StyledImg = styled.img<{ height: string }>`
  height: ${({ height }) => height};
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;
